module.exports = __webpack_public_path__ + "static/media/articles2.d76771fa.jfif";